import { render, staticRenderFns } from "./TanUpdateOTP&TDS_OTP.vue?vue&type=template&id=0a33a595&scoped=true&"
import script from "./TanUpdateOTP&TDS_OTP.vue?vue&type=script&lang=js&"
export * from "./TanUpdateOTP&TDS_OTP.vue?vue&type=script&lang=js&"
import style0 from "./TanUpdateOTP&TDS_OTP.vue?vue&type=style&index=0&id=0a33a595&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a33a595",
  null
  
)

export default component.exports